import React from "react";
import { CalendarHeart, Megaphone } from "lucide-react";

function FeedStickyNavItem({ active, disabled = false, onClick, icon: Icon, label, testId, showUnreadDot = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-current={active ? "page" : undefined}
      className={`relative flex-1 min-h-[48px] min-w-0 flex flex-col items-center justify-center gap-0.5 rounded-md2 px-1 font-ui text-[11px] font-semibold transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
        active ? "text-ink bg-ink/[0.08]" : "text-ink/70 active:bg-ink/[0.04]"
      }`}
      data-testid={testId}
    >
      <span className="relative shrink-0">
        <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} aria-hidden />
        {showUnreadDot && !active && (
          <span
            className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-ink border border-surface"
            aria-hidden
          />
        )}
      </span>
      <span className="truncate max-w-full leading-tight">{label}</span>
    </button>
  );
}

/**
 * Mobile thumb-zone tab nav for /events. Host lives in the header; desktop uses inline tab pills.
 */
export default function FeedStickyBar({
  tab,
  hasUnreadUpdates,
  onTabChange,
  dancerId = null,
}) {
  return (
    <nav
      className="feed-sticky-bar fixed inset-x-0 bottom-0 z-40 sm:hidden border-t border-subtle bg-surface px-2 pt-2 pb-[max(8px,env(safe-area-inset-bottom))]"
      data-testid="feed-sticky-bar"
      aria-label="Feed navigation"
    >
      <div className="max-w-page mx-auto flex items-stretch gap-1">
        <FeedStickyNavItem
          active={tab === "your"}
          onClick={() => onTabChange("your")}
          icon={CalendarHeart}
          label="Your Events"
          testId="feed-sticky-tab-your"
        />
        <FeedStickyNavItem
          active={tab === "updates"}
          disabled={!dancerId}
          onClick={() => onTabChange("updates")}
          icon={Megaphone}
          label="Notifications"
          testId="feed-sticky-tab-updates"
          showUnreadDot={hasUnreadUpdates}
        />
      </div>
    </nav>
  );
}
